import { useEffect } from 'react';

import type { ProductDetailMapperProps } from '@/services/mappers/productDetailMapper';
import { consumeVariantType } from '@/store/variantType/variantTypeStore';
import { viewItem } from '@/utilities/tracking';

export const useViewItemTracking = (product?: ProductDetailMapperProps) => {
  useEffect(() => {
    if (product) {
      const type = consumeVariantType();
      requestAnimationFrame(() => viewItem({ product, type }));
    }
  }, [product]);
};
